import React, { useState, useEffect } from 'react';
import {
  signInWithRedirect,
  fetchAuthSession,
  signOut,
} from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'constants/RoutePaths';
import { buildRoutePath } from 'utils/utility';
import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import TrailSafeLogo from 'assets/TrailSafe_TempLogo.png';
import { useSelector } from 'react-redux';
import { useGetUserDetailsQuery } from 'app/api/usersApiSlice';
import { useCloseActivityMutation } from 'app/api/activityApiSlice';
import MLToast from 'components/common/Toast/Toast';
import TSButton from 'components/common/Button/Button';
import dayjs from 'dayjs';
import backgroundImage from 'assets/Mountain-bg_landscape.png';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import ActivityDetail from 'components/TrailSafe/ActivityDetail/ActivityDetail';
import UserDetail from 'components/TrailSafe/UserDetail/UserDetail';
import EmergencyContact from 'components/TrailSafe/EmergencyContact/EmergencyContact';

const PublicHome = () => {
  const navigate = useNavigate();
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const [isAuth, setIsAuth] = useState(false);
  const [jwtToken, setJwtToken] = useState('');

  const myStyle = {
    bg: {
      backgroundImage: `url(${backgroundImage})`, // Use template literal or concatenation
      height: '100%', // Example: set height to cover the viewport
      backgroundSize: '100%', // Example: cover the entire element
      backgroundRepeat: 'no-repeat', // Example: prevent image from repeating
    },
    content: {
      height: '100%',
      width: '100%',
      backgroundColor: 'rgba(255, 254, 254, 0.61)',
    },
  };

  const { showToast } = MLToast();

  const userEmail = useSelector((state) => state.global?.userEmail);

  const [closeActivity] = useCloseActivityMutation();

  const handleSignIn = () => {
    localStorage.setItem('postSignInPath', `/${ROUTES.HOME}`);
    signInWithRedirect();
  };

  const handleCloseActivity = async (activityId) => {
    try {
      // Call the API to close the activity
      // Assuming you have a closeActivity mutation set up in your activityApiSlice
      const res = await closeActivity({
        activity_id: activityId,
      });
      console.log(res);
      if (res?.data[0]?.is_success) {
        showToast('Activity closed successfully!', 'success');
      } else {
        //show error message
        const errMsg = res?.data[0]?.error_message;

        showToast(errMsg || 'Something went wrong!', 'error');
      }
    } catch (error) {
      console.log('Error closing activity:', error);
    }
  };

  useEffect(() => {
    fetchJwtToken();
  }, []);

  const fetchJwtToken = async () => {
    try {
      const session = await fetchAuthSession();
      const token = session.tokens?.idToken?.toString();
      setIsAuth(!!token);
      setJwtToken(token);
    } catch (error) {
      console.log('Error fetching JWT token:', error);
    }
  };

  const { data: userData, isLoading: isUserLoading } = useGetUserDetailsQuery(
    userEmail,
    { skip: !userEmail }
  );

  if (isUserLoading) {
    return <div>Loading...</div>;
  } else {
    const content = (
      <section className="public">
        <div className="flex flex-col gap-2 items-center justify-center">
          <img className="w-[149px]" alt="TrailSafe Logo" src={TrailSafeLogo} />
          <Typography
            variant="h2"
            className="w-full items-center text-center p-2"
          >
            Your Adventure Starts Here!
          </Typography>
        </div>
        <div className="flex flex-col gap-2 pt-4 items-center justify-center">
          {isAuth ? (
            <>
              {userData?.[0]?.active_checkin &&
                userData[0].active_checkin.length > 0 && (
                  <div className="w-9/10 max-w-[600px] flex flex-col items-center gap-4 m-4">
                    <ActivityDetail
                      activity={userData[0].active_checkin[0]}
                      colourScheme="display"
                    />
                    <Typography className="w-full flex text-left text-[var(--ts-text-dark)]">
                      If you have completed this activity please click the
                      button below to update your safety status.
                    </Typography>
                    <TSButton
                      btnText="Complete Activity"
                      classList="py-4 !bg-[var(--ts-accent)] text-white"
                      onClickFunc={() =>
                        handleCloseActivity(
                          userData[0].active_checkin[0].ActivityID
                        )
                      }
                    />
                  </div>
                )}
            </>
          ) : (
            <>
              <Typography variant="h3">
                Please sign in to access more features.
              </Typography>
              <TSButton
                btnText="Sign In to TrailSafe"
                classList="py-4"
                onClickFunc={() => handleSignIn()}
              />
            </>
          )}
          {!userData?.[0]?.active_checkin && (
            <div className="px-4 py-12 flex flex-col items-center">
              <Typography variant="h4" className="text-center pb-6">
                Ready to explore the trails? Scan a QR Code or click below to
                find your next adventure!
              </Typography>
              <TSButton
                btnText="Find a Trail"
                classList="py-4"
                onClickFunc={() =>
                  navigate(`/${buildRoutePath(ROUTES.TRAIL_HOME, {})}`)
                }
              />
            </div>
          )}
        </div>
      </section>
    );
    return content;
  }
};
export default PublicHome;
